module.exports = __webpack_public_path__ + "static/img/video.ba570cde.png";